/** @format */

export const UNLISTED_MODEL_ID = 1;

export const UNCHECKED_PRODUCT_ID = 0;
